"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchWithNotifications = exports.mapStatusToMessage = exports.fetch2 = exports.post = exports.get = void 0;
const defaultParameters = {
    credentials: 'same-origin'
};
const headers = {
    'Content-Type': 'application/json'
};
const formatSuccess = (r) => r.json();
const formatError = (r) => __awaiter(void 0, void 0, void 0, function* () {
    return Promise.reject({
        status: r.status,
        data: yield r.json()
    });
});
exports.get = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const method = 'GET';
    const options = Object.assign({ method,
        headers }, defaultParameters);
    const response = yield fetch(url, options);
    if (response.ok) {
        return formatSuccess(response);
    }
    else {
        return formatError(response);
    }
});
exports.post = (url, data) => __awaiter(void 0, void 0, void 0, function* () {
    const method = 'POST';
    const body = JSON.stringify(data);
    const options = Object.assign({ method,
        headers,
        body }, defaultParameters);
    const response = yield fetch(url, options);
    if (response.ok) {
        return formatSuccess(response);
    }
    else {
        return formatError(response);
    }
});
exports.fetch2 = (url, data = null) => __awaiter(void 0, void 0, void 0, function* () {
    if (data === null || !data) {
        return exports.get(url);
    }
    return exports.post(url, data);
});
exports.mapStatusToMessage = (status) => {
    switch (status) {
        case 200:
        case 201:
            return 'growlAlert.text.save.success';
        case 404:
            return 'growl.notFound.danger';
        case 401:
        case 403:
            return 'growl.unauthorized.danger';
        case 400:
            return null;
        default:
            return 'growl.serverError.danger';
    }
};
exports.fetchWithNotifications = (url, data = null) => {
    return exports.fetch2(url, data).then(data => Promise.resolve({
        data,
        message: exports.mapStatusToMessage(200)
    }), errors => Promise.reject({
        status: errors.status,
        data: errors.data,
        message: exports.mapStatusToMessage(errors.status)
    }));
};
